import React, { Component } from 'react';
import { Markdown } from 'react-showdown';
import { Grid } from 'semantic-ui-react';
class ChangeLog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            markdown: '',
        };
    }

    componentDidMount() {
        const ChangeLog = require("../../CHANGELOG.md");
        fetch(ChangeLog)
            .then(response => {
                return response.text();
            }).then(text => {
                this.setState({
                    markdown: text
                })
            });

    }

    render() {

        return (
            <Grid>
                <Grid.Row>
                    <Markdown markdown={this.state.markdown} />
                </Grid.Row>
            </Grid>
        )
    }
}

export default ChangeLog;


// WEBPACK FOOTER //
// ./src/app/ui/ChangeLog.js